const trpInfo = () => import("@/pages/trp/trpInfo/trpInfo.vue");
const trpInfoPp = () => import("@/pages/trp/trpInfoPp/trpInfoPp.vue");
const trpInfoPurchase = () => import("@/pages/trp/trpInfoPurchase/trpInfoPurchase.vue");
const trpInfoDetail = () => import("@/pages/trp/trpInfoDetail/trpInfoDetail.vue");
export default [
  {
    path: "/trp/trpInfo",
    name: "trpInfo",
    component: trpInfo,
    meta: {
      title: "投入品信息",
      noCache: true,
      affix: true,
      path: ["投入品管理", "投入品信息"]
    }
  },
  {
    path: "/trp/trpInfoPurchase",
    name: "trpInfoPurchase",
    component: trpInfoPurchase,
    meta: {
      title: "采购入库信息",
      noCache: true,
      affix: true,
      path: ["投入品管理", "采购入库信息"]
    },
  },
  {
    path: "/trp/trpInfoPp",
    name: "trpInfoPp",
    component: trpInfoPp,
    meta: {
      title: "出库信息",
      noCache: true,
      affix: true,
      path: ["投入品管理", "出库信息"]
    },
  },
  {
    path: "/trp/trpInfoDetail",
    name: "trpInfoDetail",
    component: trpInfoDetail,
    meta: {
      title: "投入品库存",
      noCache: true,
      affix: true,
      path: ["投入品管理", "投入品库存"]
    },
  }
];



// WEBPACK FOOTER //
// ./src/router/trpInfo.js